module.exports = __webpack_public_path__ + "static/media/vibrateLight.12948028.svg";